import { Typography } from "@material-tailwind/react";

export const ResultVerifications = ({ verifications = [] }) => {
  if (verifications.length === 0) return null;

  return (
    <div className="mt-4 space-y-2">
      {verifications.map((verif, i) => (
        <div
          key={i}
          className={`flex items-start gap-2 p-2 rounded ${verif.sensitive ? "bg-yellow-50 border-l-4 border-yellow-400" : ""}`}
        >
          <div className="pt-0.5">
            {verif.passed ? (
              <svg className="h-5 w-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8.25 8.25a1 1 0 01-1.414 0l-4.25-4.25a1 1 0 011.414-1.414l3.543 3.543 7.543-7.543a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg className="h-5 w-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 8.586l4.95-4.95a1 1 0 011.414 1.414L11.414 10l4.95 4.95a1 1 0 01-1.414 1.414L10 11.414l-4.95 4.95a1 1 0 01-1.414-1.414L8.586 10 3.636 5.05a1 1 0 011.414-1.414L10 8.586z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
          <div className="flex-1">
            <Typography
              variant="small"
              className="font-medium flex items-center gap-1"
              color={verif.passed ? "black" : "red"}
            >
              {verif.check}
              {verif.sensitive && (
                <div className="relative group">
                  <svg
                    className="h-4 w-4 text-yellow-700 cursor-pointer"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M10 2a8 8 0 100 16 8 8 0 000-16zM9 8h2v4H9V8zm0 6h2v2H9v-2z" />
                  </svg>
                  <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 hidden group-hover:block bg-yellow-100 text-yellow-900 text-xs rounded px-2 py-1 shadow-lg z-10 whitespace-nowrap">
                    Información sensible - mantener discreción
                  </div>
                </div>
              )}
            </Typography>
            {verif.message && (
              <Typography variant="small" color="gray" className="text-xs">
                {verif.message}
              </Typography>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
